export const attentionTypes = [
  { level: 0, value: 'AVERTING', label: 'Absent', tooltip: 'No eye contact' },
  { level: 1, value: 'AVOIDANT', label: 'Avoidant', tooltip: 'Looks away repeatedly' },
  { level: 2, value: 'INDIFFERENT', label: 'Limited', tooltip: 'Occasional eye contact' },
  { level: 3, value: 'NORMAL', label: 'Appropriate', tooltip: 'Regular eye contact' },
  { level: 4, value: 'ATTENTIVE', label: 'Attentive', tooltip: 'Frequent eye contact' },
  { level: 5, value: 'FOCUSED', label: 'Sustained', tooltip: 'Prolonged eye contact' },
  { level: 6, value: 'FIXATED', label: 'Fixated', tooltip: 'Unbroken eye contact' }
];

export const attentionTooltips = Object.assign({}, ...attentionTypes.map(type => ({ [type.level]: type.tooltip })));
export const attentionValuesByLevel = Object.assign({}, ...attentionTypes.map(type => ({ [type.level]: type.value })));
export const attentionLevelsByValue = Object.assign({}, ...attentionTypes.map(type => ({ [type.value]: type.level })));

export const defaultAttentionValue = 'NORMAL';
